export const interfaceLayerName = "aat";
export const mainContainer = "#celine-main";
export const reservedProps = [
    "journey",
    "subJourney",
    "changesetid",
    "connectedExperience",
    "type",
    "event",
    "element",
    "elementId",
    "elementName",
    "elementClass",
    "elementLabel",
    "interval",
    "isValid",
];
const eventPrefix = "absa.access.rum";
export const domEventTypes = {
    click: `click`,
    hover: "hover",
    mouseleave: "mouseleave",
};
export const eventTypes = {
    fieldChange: `${eventPrefix}.element_change_event`,
    clickEvent: "click-event",
    elementChange: `${eventPrefix}.element_change_event`,
    domEvent: `${eventPrefix}.element_dom_event`,
    journeyStart: `${eventPrefix}.journey_start_event`,
    journeyRecord: `${eventPrefix}.journey_record_event`,
    journeyComplete: `${eventPrefix}.journey_complete_event`,
    pageView: `${eventPrefix}.page_view_event`,
};
const elemAttributesPrefix = "data";
export const elemAttributes = {
    state: `${elemAttributesPrefix}-trk-st`,
    journey: `${elemAttributesPrefix}-trk-jny`,
    startTime: `${elemAttributesPrefix}-trk-start-tm`,
    endTime: `${elemAttributesPrefix}-trk-end-tm`,
};
export const dispatchTypes = {
    startJourney: "startJourney",
    completeJourney: "completeJourney",
};
export const elementAttributes = {
    key: "aat-key",
    ignoreCache: "aat-ignoreCache",
    meta: "aat-meta",
    action: "aat-action",
    track: "aat",
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/types.js
// module id = ./node_modules/@celine/passive-tracking/dist/types.js
// module chunks = 0